<div class="distribution-range-selectors">
    <p>{{'analytics.group_data' | translate}}</p>
    <button type="button" class="btn btn-default" [ngClass]="{'btn-default-active': rangeSelector==='day'}" (click)="changeTimeSector('day')">{{'analytics.day' | translate}}</button>
    <button type="button" class="btn btn-default" [ngClass]="{'btn-default-active': rangeSelector==='week'}" (click)="changeTimeSector('week')">{{'analytics.week' | translate}}</button>
    <button type="button" class="btn btn-default" [ngClass]="{'btn-default-active': rangeSelector==='month'}" (click)="changeTimeSector('month')">{{'analytics.month' | translate}}</button>
</div>


<highcharts-chart [constructorType]="chartConstructor"
                  [options]="(chartOptions$ | async)!"
                  [oneToOne]="true"
                  style="width: 100%; display: block;"></highcharts-chart>